import React from 'react';
import clsx from 'clsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InfoButton from '../../../common/data_display/InfoButton';
import InfoModal from '../../../common/data_display/InfoModal';
import { useTableStyles } from '../../../common/styles/TableStyles';
import { secondaryMain } from '../../../constants/colors';

export default function AdmDeliveryTable(props) {
  const classes = useTableStyles();
  const { percentage_open_at_d0, percentage_open_at_d2 } = props;

  const [modalOpen, setModalOpen] = React.useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const getColorClass = (value, redThreshold, yellowThreshold) => {
    if (isNaN(value)) return null;

    if (value > redThreshold) {
      return classes.redCell;
    }
    else if (value >= yellowThreshold) {
      return classes.yellowCell;
    }
    else {
      return classes.greenCell;
    }
  }

  const title = 'ADM Delivery Readiness';

  // Safely format percentage values
  const formatPercentage = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return 'N/A';
    }
    return typeof value === 'number' ? value.toFixed(2) : 'N/A';
  };

  const rows = [
    {
      body: <React.Fragment><b>Percentage Open Defects</b></React.Fragment>,
      d0: formatPercentage(percentage_open_at_d0),
      d2: formatPercentage(percentage_open_at_d2),
      redThreshold: 10,
      yellowThreshold: 5,
    },
  ];

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography className={classes.title} gutterBottom variant="h3">
            {title}
          </Typography>

          <div className={classes.infoButton}>
            <InfoButton onClick={handleModalOpen} />
          </div>

          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow className={classes.head}>
                <TableCell className={clsx(classes.headCell, classes.rowValue)} component="th" scope="row" align="center"></TableCell>
                <TableCell className={clsx(classes.headCell, classes.rowValue)} align="center">
                  D0
                </TableCell>
                <TableCell className={clsx(classes.headCell, classes.rowValue)} align="center">
                  D2
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => {
                const d0Value = row.d0 === 'N/A' ? NaN : parseFloat(row.d0);
                const d2Value = row.d2 === 'N/A' ? NaN : parseFloat(row.d2);

                const d0ColorClass = getColorClass(d0Value, row.redThreshold, row.yellowThreshold);
                const d2ColorClass = getColorClass(d2Value, row.redThreshold, row.yellowThreshold);
                const leftClass = clsx(d0ColorClass, classes.thresholdCellLeft);
                const rightClass = d2ColorClass;

                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center" className={clsx(classes.cell, classes.nameCell, classes.rowName)}>
                      {row.body}
                    </TableCell>
                    <TableCell align="center" className={clsx(classes.cell, classes.valueCell, leftClass)}>
                      <b>{row.d0 === 'N/A' ? row.d0 : `${row.d0}%`}</b>
                    </TableCell>
                    <TableCell align="center" className={clsx(classes.cell, classes.valueCell, rightClass)}>
                      <b>{row.d2 === 'N/A' ? row.d2 : `${row.d2}%`}</b>
                    </TableCell>
                  </TableRow>
              )})}
            </TableBody>
          </Table>

        </CardContent>
      </Card>

      <InfoModal title={title} open={modalOpen} onClose={handleModalClose}>
        <div>
          <b style={{color: secondaryMain }}>Note:</b>
          <br/>
          <b>Percentage Open</b> = Predicted Open Defects / Predicted Defects
        </div>
      </InfoModal>
    </React.Fragment>
  );
}
